import PropTypes from 'prop-types';
import React from 'react';
import { COMMUNITY_ENGAGEMENT_INTERACTION_CODE } from '../constants';
import { CommunityEngagementInteractionCardBody } from './CommunityEngagementInteractionCardBody';
import { InteractionCardHeader } from './InteractionCardHeader';

export function StructuredInteractionCard({ interaction }) {
  const typeCode = interaction.type_concept.code;
  const typeLabel = interaction.type_concept.display;
  const isCommunityEngagementInteraction = typeCode === COMMUNITY_ENGAGEMENT_INTERACTION_CODE;

  return (
    <div
      className="mb-4 overflow-hidden rounded border border-solid border-dark-border-blue"
    >
      <div className="bg-medium-fill-grey px-4 pt-4">
        <InteractionCardHeader
          title={typeLabel}
          updatedAt={interaction.updated_at}
        />
      </div>
      {isCommunityEngagementInteraction && (
        <div className="bg-white px-4 py-4">
          <CommunityEngagementInteractionCardBody interaction={interaction} />
        </div>
      )}
    </div>
  );
}

StructuredInteractionCard.propTypes = {
  interaction: PropTypes.object.isRequired,
};
